module.exports = __webpack_public_path__ + "static/media/tree1.2a6df41d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/tree1.jpg
// module id = 37
// module chunks = 0